module.exports = __webpack_public_path__ + "img/max7.4b8e1ca3.jpg";